import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SystemDiagramsManagementPage } from "src/components/views/erp/common/systemDiagrams/SystemDiagramsManagementPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/common/systemDiagrams")({
	staticData: { title: i18n.t("system_diagrams"), legacyViewKey: "systemDiagramsManagement" },
	component: RouteComponent,
});

function RouteComponent() {
	return <SystemDiagramsManagementPage />;
}
